// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../navbar/navbar.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quickAcces-container {
  background-color: #ffffff !important;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.16);
  font-family: "Lato", sans-serif !important;
  top: 0 !important;
  max-width: 460px;
  display: flex;
  flex-direction: column;
}
.quickAcces-container .quickAccess-title-container {
  text-align: left;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
  margin: 49px 0px 0px 4px !important;
}
.quickAcces-container .text-bottom-quickAccess {
  display: flex;
  flex-direction: row !important;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}
.quickAcces-container .mma-logo {
  height: 40px;
  width: 80px;
  margin-bottom: 0.5rem;
  margin-left: 0.3rem;
  padding: 0;
}
.quickAcces-container .icon-search {
  cursor: pointer;
}
.quickAcces-container .quickAccess-list-container {
  margin-top: 2em;
}
.quickAcces-container .quickAccess-title {
  margin-top: 1rem;
  margin-left: 1rem;
  margin-bottom: 0rem;
  text-align: left;
  font-weight: 800;
  font-size: 17px;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
  padding-left: 5px !important;
}
.quickAcces-container .quickAccess-subtitle {
  margin-top: 1rem;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  background-color: rgb(120, 204, 210);
  border-radius: 1rem;
  padding-left: 5px;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: left;
  font-size: 17px;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}
.quickAcces-container .container-accordion {
  overflow-y: scroll;
  direction: rtl;
}
.quickAcces-container .input-search-form-group {
  border: 2px solid #78ccd2 !important;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #cccccc;
  border-radius: 19px;
  opacity: 1;
  width: 85% !important;
  height: 2.5rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  top: 1rem;
}
.quickAcces-container .searchBar-quickAccess {
  display: flex;
  justify-content: center;
  align-items: center;
}
.quickAcces-container .li {
  justify-content: flex-start;
}
.quickAcces-container .block {
  display: block;
}
.quickAcces-container li {
  font-size: 17px !important;
  display: flex;
  align-items: center;
  list-style: none;
  height: 45px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.quickAcces-container .divisor-line {
  background: #ffc14d 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 2px;
  width: 75%;
  position: sticky;
  top: 90px;
  margin-top: -1rem;
  color: transparent;
}
.quickAcces-container .quickAccess-list-group-item {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-left: none;
  border-right: none;
  border-top: 1px;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 17px;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}
.quickAcces-container .container-list-group {
  margin-top: 1rem !important;
}
.quickAcces-container .ul-none {
  display: none;
}
.quickAcces-container .quickAccess-ul {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  margin-top: -0.5rem;
  margin-left: 0.3rem;
}
.quickAcces-container .quickAccess-ul a {
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 17px;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}
.quickAcces-container .chelmsford-link {
  text-decoration: none;
  color: #8f003c !important;
}

.height-logout {
  height: 100%;
  position: sticky;
  top: 0px !important;
}

.height-login {
  height: auto;
}

.container-title-sutitle {
  padding: 1rem !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  width: 40px !important;
  max-height: 7em;
}

.qa-logo {
  margin-left: 20px !important;
}

.li-quickAccess {
  display: flex !important;
  justify-content: flex-end !important;
}

.link-external {
  color: rgb(26, 25, 25);
  font-size: 15px;
  font-family: "Lato", sans-serif !important;
}

.item-skeleton {
  margin-bottom: 30px !important;
}

@media (max-width: 1200px) {
  .close-button {
    display: flex;
    position: relative !important;
    top: 0rem;
  }
}
@media (min-width: 1200px) and (max-width: 1500px) {
  .text-bottom-quickAccess h4 {
    font-size: 14px;
  }
  .text-bottom-quickAccess label {
    font-size: 12px !important;
  }
  .text-bottom-quickAccess .mma-logo {
    height: 30px;
    width: 55px;
  }
}
.container {
  flex: 1 1;
  justify-content: flex-start;
  height: 100vh;
  position: fixed !important;
  width: 21.5rem !important;
}

@media (min-width: 1200px) and (max-width: 1300px) {
  .container {
    flex: 1 1;
    justify-content: flex-start;
    height: 100vh;
    position: fixed !important;
    width: 19rem !important;
  }
}
@media (max-width: 576px) {
  .text-bottom-quickAccess {
    margin-top: 0.5rem;
    margin-bottom: -0.5rem;
  }
  .quickAccess-ul {
    margin-bottom: -2rem;
  }
}
.quick-access-subtitle-mobile {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  background-color: rgb(120, 204, 210);
  border-radius: 1rem;
  padding-left: 5px;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: left;
  font-size: 17px;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
  width: 90%;
}

.quick-access-mobile-link {
  border-bottom: 0.6px solid #E4E6EB;
  color: rgb(26, 25, 25) !important;
  padding: 0.9rem !important;
}

.quick-access-mobile-nav {
  width: 100% !important;
  margin: 0 !important;
}

/* Retirees menu structure styles */
.quickAccess-section-header {
  font-weight: 700 !important;
  background-color: #f8f9fa;
  cursor: pointer;
}

.quickAccess-section-header.quickAccess-section-title {
  font-weight: 700 !important;
  font-size: 17px !important;
  margin-top: 0.5rem;
  background-color: transparent;
  pointer-events: none;
  cursor: default;
}

.quickAccess-section-header.quickAccess-expandable {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.quickAccess-section-header.quickAccess-expandable:hover {
  background-color: #e9ecef;
}

.quickAccess-nested-item {
  padding-left: 2rem !important;
  font-weight: 400 !important;
}

.quickAccess-nested-item:hover {
  background-color: #f8f9fa;
}

.quickAccess-arrow {
  font-size: 24px;
  font-weight: 700;
  transition: transform 0.3s ease;
  display: inline-block;
  margin-right: 0.5rem;
}

.quickAccess-arrow.expanded {
  transform: rotate(90deg);
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/quickAccess/quickAccess.scss","webpack://./src/sass/utilities/_variables.scss","webpack://./src/sass/layout/quickAccess/quickAccess.css"],"names":[],"mappings":"AAIA;EACE,oCAAA;EACA,4CAAA;EACA,0CCLK;EDML,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AEFF;AFIE;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,mCAAA;AEFJ;AFKE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AEHJ;AFME;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;AEJJ;AFOE;EACE,eAAA;AELJ;AFQE;EACE,eAAA;AENJ;AFSE;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CClDG;EDmDH,mBAAA;EACA,cAAA;EACA,UAAA;EACA,4BAAA;AEPJ;AFUE;EACE,gBAAA;EACA,gBAAA;EACA,0CC5DG;ED6DH,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0CCxEG;ED0EH,mBAAA;EACA,cAAA;EACA,UAAA;AETJ;AFYE;EACE,kBAAA;EAEA,cAAA;AEXJ;AFcE;EACE,oCAAA;EACA,+CAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AEZJ;AFeE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AEbJ;AFgBE;EACE,2BAAA;AEdJ;AFiBE;EACE,cAAA;AEfJ;AFkBE;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;EAIA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AEnBJ;AFsBE;EACE,+CAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AEpBJ;AFuBE;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CClJG;EDmJH,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AErBJ;AFwBE;EACE,2BAAA;AEtBJ;AFyBE;EACE,aAAA;AEvBJ;AF0BE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AExBJ;AF0BI;EACE,gBAAA;EACA,0CC1KC;ED2KD,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AExBN;AF4BE;EACE,qBAAA;EACA,yBAAA;AE1BJ;;AF8BA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;AE3BF;;AF8BA;EACE,YAAA;AE3BF;;AF8BA;EACE,wBAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,sCAAA;EACA,sBAAA;EACA,eAAA;AE3BF;;AF8BA;EACE,4BAAA;AE3BF;;AF8BA;EACE,wBAAA;EACA,oCAAA;AE3BF;;AF8BA;EACE,sBC9MM;ED+MN,eAAA;EACA,0CCxNK;AC6LP;;AF8BA;EACE,8BAAA;AE3BF;;AF8BA;EACE;IACE,aAAA;IACA,6BAAA;IACA,SAAA;EE3BF;AACF;AF8BA;EAEI;IACE,eAAA;EE7BJ;EFgCE;IACE,0BAAA;EE9BJ;EFiCE;IACE,YAAA;IACA,WAAA;EE/BJ;AACF;AFmCA;EACE,SAAA;EACA,2BAAA;EACA,aAAA;EACA,0BAAA;EACA,yBAAA;AEjCF;;AFoCA;EACE;IACE,SAAA;IACA,2BAAA;IACA,aAAA;IACA,0BAAA;IACA,uBAAA;EEjCF;AACF;AFoCA;EACE;IACE,kBAAA;IACA,sBAAA;EElCF;EFoCA;IACE,oBAAA;EElCF;AACF;AFuCA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,0CC1RK;ED2RL,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0CCtSK;EDwSL,mBAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;AEtCF;;AFyCA;EACE,kCAAA;EACA,iCAAA;EACA,0BAAA;AEtCF;;AFwCA;EACE,sBAAA;EACA,oBAAA;AErCF;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["@import \"../../layout/navbar/navbar.css\";\n@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.quickAcces-container {\n  background-color: #ffffff !important;\n  box-shadow: 0px 3px 15px rgb(0 0 0 / 16%);\n  font-family: $Font;\n  top: 0 !important;\n  max-width: 460px;\n  display: flex;\n  flex-direction: column;\n\n  .quickAccess-title-container {\n    text-align: left;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n    margin: 49px 0px 0px 4px !important;\n  }\n\n  .text-bottom-quickAccess {\n    display: flex;\n    flex-direction: row !important;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n\n  .mma-logo {\n    height: 40px;\n    width: 80px;\n    margin-bottom: 0.5rem;\n    margin-left: 0.3rem;\n    padding: 0;\n  }\n\n  .icon-search {\n    cursor: pointer;\n  }\n\n  .quickAccess-list-container {\n    margin-top: 2em;\n  }\n\n  .quickAccess-title {\n    margin-top: 1rem;\n    margin-left: 1rem;\n    margin-bottom: 0rem;\n    text-align: left;\n    font-weight: 800;\n    font-size: 16px/30px;\n    font-family: $Font;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n    padding-left: 5px !important;\n  }\n\n  .quickAccess-subtitle {\n    margin-top: 1rem;\n    text-align: left;\n    font-family: $Font;\n    letter-spacing: 0px;\n    background-color: rgb(120 204 210);\n    border-radius: 1rem;\n    padding-left: 5px;\n    height: 2rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    text-align: left;\n    font-size: 17px;\n    font-family: $Font;\n\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n  }\n\n  .container-accordion {\n    overflow-y: scroll;\n    // height: 42rem;\n    direction: rtl;\n  }\n\n  .input-search-form-group {\n    border: 2px solid #78ccd2 !important;\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #cccccc;\n    border-radius: 19px;\n    opacity: 1;\n    width: 85% !important;\n    height: 2.5rem;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    position: relative;\n    top: 1rem;\n  }\n\n  .searchBar-quickAccess {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .li {\n    justify-content: flex-start;\n  }\n\n  .block {\n    display: block;\n  }\n\n  li {\n    font-size: 17px !important;\n    display: flex;\n    align-items: center;\n    // margin-top: 28px;\n    // margin-left: 5px;\n    // justify-content: flex-end;\n    list-style: none;\n    height: 45px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n\n  .divisor-line {\n    background: #ffc14d 0% 0% no-repeat padding-box;\n    opacity: 1;\n    height: 2px;\n    width: 75%;\n    position: sticky;\n    top: 90px;\n    margin-top: -1rem;\n    color: transparent;\n  }\n\n  .quickAccess-list-group-item {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-left: none;\n    border-right: none;\n    border-top: 1px;\n    text-align: left;\n    font-family: $Font;\n    font-size: 17px;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n  }\n\n  .container-list-group {\n    margin-top: 1rem !important;\n  }\n\n  .ul-none {\n    display: none;\n  }\n\n  .quickAccess-ul {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    margin-top: -0.5rem;\n    margin-left: 0.3rem;\n\n    a {\n      text-align: left;\n      font-family: $Font;\n      font-size: 17px;\n      letter-spacing: 0px;\n      color: #1a1919;\n      opacity: 1;\n    }\n  }\n\n  .chelmsford-link {\n    text-decoration: none;\n    color: #8f003c !important;\n  }\n}\n\n.height-logout {\n  height: 100%;\n  position: sticky;\n  top: 0px !important;\n}\n\n.height-login {\n  height: auto;\n}\n\n.container-title-sutitle {\n  padding: 1rem !important;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  width: 40px !important;\n  max-height: 7em;\n}\n\n.qa-logo {\n  margin-left: 20px !important;\n}\n\n.li-quickAccess {\n  display: flex !important;\n  justify-content: flex-end !important;\n}\n\n.link-external {\n  color: $Black;\n  font-size: 15px;\n  font-family: $Font;\n}\n\n.item-skeleton {\n  margin-bottom: 30px !important;\n}\n\n@media (max-width: 1200px) {\n  .close-button {\n    display: flex;\n    position: relative !important;\n    top: 0rem;\n  }\n}\n\n@media (min-width: 1200px) and (max-width: 1500px) {\n  .text-bottom-quickAccess {\n    h4 {\n      font-size: 14px;\n    }\n\n    label {\n      font-size: 12px !important;\n    }\n\n    .mma-logo {\n      height: 30px;\n      width: 55px;\n    }\n  }\n}\n\n.container {\n  flex: 1;\n  justify-content: flex-start;\n  height: 100vh;\n  position: fixed !important;\n  width: 21.5rem !important;\n}\n\n@media (min-width: 1200px) and (max-width: 1300px) {\n  .container {\n    flex: 1;\n    justify-content: flex-start;\n    height: 100vh;\n    position: fixed !important;\n    width: 19rem !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .text-bottom-quickAccess {\n    margin-top: 0.5rem;\n    margin-bottom: -0.5rem;\n  }\n  .quickAccess-ul{\n    margin-bottom: -2rem;\n  }\n}\n\n\n\n.quick-access-subtitle-mobile {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  text-align: left;\n  font-family: $Font;\n  letter-spacing: 0px;\n  background-color: rgb(120 204 210);\n  border-radius: 1rem;\n  padding-left: 5px;\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  text-align: left;\n  font-size: 16px/20px;\n  font-family: $Font;\n\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n  width: 90%;\n}\n\n.quick-access-mobile-link {\n  border-bottom: 0.6px solid #E4E6EB;\n  color: $Black !important;\n  padding: 0.9rem !important;\n}\n.quick-access-mobile-nav {\n  width: 100% !important;\n  margin: 0 !important;\n}","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n","@import \"../../layout/navbar/navbar.css\";\n.quickAcces-container {\n  background-color: #ffffff !important;\n  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.16);\n  font-family: \"Lato\", sans-serif !important;\n  top: 0 !important;\n  max-width: 460px;\n  display: flex;\n  flex-direction: column;\n}\n.quickAcces-container .quickAccess-title-container {\n  text-align: left;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n  margin: 49px 0px 0px 4px !important;\n}\n.quickAcces-container .text-bottom-quickAccess {\n  display: flex;\n  flex-direction: row !important;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n.quickAcces-container .mma-logo {\n  height: 40px;\n  width: 80px;\n  margin-bottom: 0.5rem;\n  margin-left: 0.3rem;\n  padding: 0;\n}\n.quickAcces-container .icon-search {\n  cursor: pointer;\n}\n.quickAcces-container .quickAccess-list-container {\n  margin-top: 2em;\n}\n.quickAcces-container .quickAccess-title {\n  margin-top: 1rem;\n  margin-left: 1rem;\n  margin-bottom: 0rem;\n  text-align: left;\n  font-weight: 800;\n  font-size: 17px;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n  padding-left: 5px !important;\n}\n.quickAcces-container .quickAccess-subtitle {\n  margin-top: 1rem;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  background-color: rgb(120, 204, 210);\n  border-radius: 1rem;\n  padding-left: 5px;\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  text-align: left;\n  font-size: 17px;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.quickAcces-container .container-accordion {\n  overflow-y: scroll;\n  direction: rtl;\n}\n.quickAcces-container .input-search-form-group {\n  border: 2px solid #78ccd2 !important;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 1px solid #cccccc;\n  border-radius: 19px;\n  opacity: 1;\n  width: 85% !important;\n  height: 2.5rem;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  position: relative;\n  top: 1rem;\n}\n.quickAcces-container .searchBar-quickAccess {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.quickAcces-container .li {\n  justify-content: flex-start;\n}\n.quickAcces-container .block {\n  display: block;\n}\n.quickAcces-container li {\n  font-size: 17px !important;\n  display: flex;\n  align-items: center;\n  list-style: none;\n  height: 45px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.quickAcces-container .divisor-line {\n  background: #ffc14d 0% 0% no-repeat padding-box;\n  opacity: 1;\n  height: 2px;\n  width: 75%;\n  position: sticky;\n  top: 90px;\n  margin-top: -1rem;\n  color: transparent;\n}\n.quickAcces-container .quickAccess-list-group-item {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-left: none;\n  border-right: none;\n  border-top: 1px;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 17px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.quickAcces-container .container-list-group {\n  margin-top: 1rem !important;\n}\n.quickAcces-container .ul-none {\n  display: none;\n}\n.quickAcces-container .quickAccess-ul {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  margin-top: -0.5rem;\n  margin-left: 0.3rem;\n}\n.quickAcces-container .quickAccess-ul a {\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 17px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.quickAcces-container .chelmsford-link {\n  text-decoration: none;\n  color: #8f003c !important;\n}\n\n.height-logout {\n  height: 100%;\n  position: sticky;\n  top: 0px !important;\n}\n\n.height-login {\n  height: auto;\n}\n\n.container-title-sutitle {\n  padding: 1rem !important;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  width: 40px !important;\n  max-height: 7em;\n}\n\n.qa-logo {\n  margin-left: 20px !important;\n}\n\n.li-quickAccess {\n  display: flex !important;\n  justify-content: flex-end !important;\n}\n\n.link-external {\n  color: rgb(26, 25, 25);\n  font-size: 15px;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.item-skeleton {\n  margin-bottom: 30px !important;\n}\n\n@media (max-width: 1200px) {\n  .close-button {\n    display: flex;\n    position: relative !important;\n    top: 0rem;\n  }\n}\n@media (min-width: 1200px) and (max-width: 1500px) {\n  .text-bottom-quickAccess h4 {\n    font-size: 14px;\n  }\n  .text-bottom-quickAccess label {\n    font-size: 12px !important;\n  }\n  .text-bottom-quickAccess .mma-logo {\n    height: 30px;\n    width: 55px;\n  }\n}\n.container {\n  flex: 1;\n  justify-content: flex-start;\n  height: 100vh;\n  position: fixed !important;\n  width: 21.5rem !important;\n}\n\n@media (min-width: 1200px) and (max-width: 1300px) {\n  .container {\n    flex: 1;\n    justify-content: flex-start;\n    height: 100vh;\n    position: fixed !important;\n    width: 19rem !important;\n  }\n}\n@media (max-width: 576px) {\n  .text-bottom-quickAccess {\n    margin-top: 0.5rem;\n    margin-bottom: -0.5rem;\n  }\n  .quickAccess-ul {\n    margin-bottom: -2rem;\n  }\n}\n.quick-access-subtitle-mobile {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  background-color: rgb(120, 204, 210);\n  border-radius: 1rem;\n  padding-left: 5px;\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  text-align: left;\n  font-size: 17px;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n  width: 90%;\n}\n\n.quick-access-mobile-link {\n  border-bottom: 0.6px solid #E4E6EB;\n  color: rgb(26, 25, 25) !important;\n  padding: 0.9rem !important;\n}\n\n.quick-access-mobile-nav {\n  width: 100% !important;\n  margin: 0 !important;\n}\n\n/* Retirees menu structure styles */\n.quickAccess-section-header {\n  font-weight: 700 !important;\n  background-color: #f8f9fa;\n  cursor: pointer;\n}\n\n.quickAccess-section-header.quickAccess-section-title {\n  font-weight: 700 !important;\n  font-size: 17px !important;\n  margin-top: 0.5rem;\n  background-color: transparent;\n  pointer-events: none;\n  cursor: default;\n}\n\n.quickAccess-section-header.quickAccess-expandable {\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.quickAccess-section-header.quickAccess-expandable:hover {\n  background-color: #e9ecef;\n}\n\n.quickAccess-nested-item {\n  padding-left: 2rem !important;\n  font-weight: 400 !important;\n}\n\n.quickAccess-nested-item:hover {\n  background-color: #f8f9fa;\n}\n\n.quickAccess-arrow {\n  font-size: 24px;\n  font-weight: 700;\n  transition: transform 0.3s ease;\n  display: inline-block;\n  margin-right: 0.5rem;\n}\n\n.quickAccess-arrow.expanded {\n  transform: rotate(90deg);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
